namespace RioERP.Web.Enums {
    export enum InvoiceTo {
        Customer = 1,
        Franchisee = 2
    }
    Serenity.Decorators.registerEnumType(InvoiceTo, 'RioERP.Web.Enums.InvoiceTo');
}
